import { AfterViewInit, Component, ComponentRef, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { InteractionService } from '../../../services/interaction.service';
import { CommunicationService } from '../../../services/communication.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { ConfigLoaderService } from '../../../config/configloader.service';
import { SettingsService } from '../../../services/settings.service';
import { UserstoryService } from '../../../services/userstory.service';
import { Sticker } from '../../../models/sticker';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { StickerIconComponent } from './sticker-icon/sticker-icon.component';
import { TranslateService } from '@ngx-translate/core';
import { StickerService } from '../../../services/sticker.service';
import { Subscription } from 'rxjs';
import { MatTable } from '@angular/material/table';
import interact from 'interactjs';
import { AwallComponentEvent } from '../../../models/awallComponentEvent';
import { KanbanBoardViewComponent } from '../../../actionviews/kanban-board-view/kanban-board-view.component';
import { map } from 'rxjs/operators';
import { IWidget } from '../../../interfaces/iWidget';

@Component({
  selector: 'app-sticker-widget',
  templateUrl: './sticker-widget.component.html',
  styleUrls: ['./sticker-widget.component.scss'],
  animations: [
  trigger('detailExpand', [
    state('collapsed', style({ height: '0px', minHeight: '0' })),
    state('expanded', style({ height: '*' })),
    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  })
export class StickerWidgetComponent implements IWidget, OnInit, AfterViewInit, OnDestroy {
  static widgetName = 'stickers';
  @ViewChild('divcointainer') stickerwidget: ElementRef;
  @ViewChild(MatTable) table: MatTable<any>;

  private interactedClass = 'resizedwidget';
  private subscriptions: Subscription[] = [];
  private whRatio = 90.8 / 57.5; // width-height ratio
  public isSmallStickerWidget = true;
  public isToolbarVisible = false;
  public templateStickers: Sticker[] = [];
  public isUndocked = false;
  public displayedColumns: string[] = ['icon', 'comment', 'actions'];
  public expandedElement: Sticker | null;
  protected defaultStickers: Sticker[] = [];
  protected readonly baseURL: string;
  protected readonly projectKey: string;
  protected getWidgetURL;
  protected createDefaultStickersURL;
  protected dropEventName;
  protected widgetClass: string;
  protected dropzoneClass: string;
  protected draggableClass: string;
  private element: ElementRef;
  public componentRef: ComponentRef<any>;

  // Initializes the viewport sizes
  private screenHeight;
  private screenWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  constructor(
    private http: HttpClient,
    private configService: ConfigLoaderService,
    private settingsService: SettingsService,
    private interactionService: InteractionService,
    private communicationService: CommunicationService,
    private userStoryService: UserstoryService,
    private stickerService: StickerService,
    private translate: TranslateService,
    private dialog: MatDialog
  ) {
    this.widgetClass = '.stickerwidget';
    this.dropzoneClass = '.stickerdropzone';
    this.draggableClass = '.draggable-sticker';
    this.dropEventName = 'sticker-dropped';
    this.baseURL = configService.settings.pyWallServer.url;
    this.projectKey = settingsService.getProjectName();
    this.defaultStickers = configService.settings.DefaultStickers.stickers;
    this.getWidgetURL = `${this.baseURL}stickers/?projectId=${this.projectKey}&elementType=template`;
    this.createDefaultStickersURL = `${this.baseURL}stickers/`;
  }

  ngOnInit() {
    this.initDefaultStickerComponents();
  }

  ngAfterViewInit() {
    this.setupTouchInteractions();
    this.setupinteraction();
  }

  ngOnDestroy(): void {
    for (const ev of this.subscriptions) {
      ev.unsubscribe();
    }
    // Cleanup interactjs-listeners
    this.interactionService.unset(this.widgetClass);
    this.interactionService.unset(this.draggableClass);
    this.interactionService.unset(this.dropzoneClass);
    this.templateStickers = [];
  }

  protected initDefaultStickerComponents() {
    // Try to load already created sticker templates
    // TODO
    this.http.get<Sticker[]>(this.getWidgetURL).pipe(map(data => this.stickerService.mapJSONToStickers(data))).subscribe(data => {
      // if the project was already loaded once add sticker templates
      this.templateStickers = data;

      // if the project was never loaded create sticker templates
      if (data.length === 0) {
        this.defaultStickers.forEach((sticker, index) => {
          // set project key for sticker templates
          sticker.projectKey = this.projectKey;

          // create default sticker templates
          const res = this.http.post<Sticker>(this.createDefaultStickersURL, sticker);
          res.subscribe(create_repsonse => {
            // set the returned it for sticker templates
            this.defaultStickers[index].id = create_repsonse['id'];
          });
        });
        // add the created templates for display
        this.templateStickers = this.defaultStickers;
      }
    });
  }

  private setupinteraction() {
    const html: HTMLElement = this.stickerwidget.nativeElement;
    const maxHeight = html.offsetHeight * 5.5; // Adjustment of the factor to the max height
    const minHeight = html.offsetHeight * 4.3; // Adjustment of the factor to the min height
    const maxWidth = maxHeight * this.whRatio;
    const minWidth = minHeight * this.whRatio;
    const obj = this;

    this.interactionService.addPinchToResizeInteraction(this.widgetClass, (event) => {
      event.target.classList.add(obj.interactedClass);
    }, ((size) => {
      size.newHeight = Math.min(Math.max(size.newHeight, minHeight), maxHeight);
      size.newWidth = Math.min(Math.max(size.newWidth, minWidth), maxWidth);
    }));


    this.interactionService.addDragInteraction(this.widgetClass, (event) => {
      event.target.classList.add(this.interactedClass);
    }, (event) => {
    }, (event) => {
      // check if small stickers widget
      if (this.isSmallStickerWidget) {
        this.isSmallStickerWidget = false;
        this.isToolbarVisible = true;

        const target: HTMLElement = event.target;
        // const stickerWidget: any = target.closest(this.widgetClass);
        this.isUndocked = true;
        // this.displayedColumns = ['icon', 'comment'];
      }
    });
  }

  /**
   * Reset widget if reset button is clicked.
   * @param event
   */
  reset(event: any) {
    const closest = event.target.closest(`.${this.interactedClass}`);
    this.resetWidget(closest);
  }

  private resetWidget(target: HTMLElement) {
    this.smallStickerWidget();
    this.isSmallStickerWidget = true;
    this.interactionService.undoDragInteraction(target);
    this.interactionService.undoPinchToResizeInteraction(target);
    target.classList.remove(this.interactedClass);
  }

  private smallStickerWidget() {
    this.isUndocked = false;
    this.isToolbarVisible = false;
  }

  private setupTouchInteractions() {
    this.setupStickerDropzone();
    this.setupStickerDragInteraction();
  }

  setPosition(x: number, y: number) {
    this.element.nativeElement.style.left = x + 'px';
    this.element.nativeElement.style.top = y + 'px';
  }

  private setupStickerDragInteraction() {
    const classThis = this;
    let clone;

    interact(this.draggableClass)
      .draggable({
        onstart: function (event) {
          const target: HTMLElement = event.target;

          // We create a clone of the dragged sticker here that takes the place of the dragged-out one
          clone = target.cloneNode(true);
          target.parentElement.insertBefore(clone, target);

          const widget: any = target.closest('.widget').parentElement;

          const x = (parseFloat(widget.getAttribute('data-x')) || 0);
          const y = (parseFloat(widget.getAttribute('data-y')) || 0);

          target.style.position = 'absolute';
          target.style.zIndex = '2000';

          // when the stickers widget gets moved, the absolute origin point isnt the top left corner of the display anymore
          // the originpoint becomes the top left point of the div
          // so we need to substract the widget position to get our normal absolute position
          if (widget.hasAttribute('data-x')) {
            target.style.left = (event.clientX - widget.offsetLeft - x - target.offsetWidth / 2) + 'px';
            target.style.top = (event.clientY - widget.offsetTop - y - target.offsetHeight / 2) + 'px';
          } else {
            target.style.left = (event.clientX) + 'px';
            target.style.top = (event.clientY) + 'px';
          }
        },
        // call this function on every dragmove event
        onmove: function (event) {
          const target: HTMLElement = event.target;
          // keep the dragged position in the data-x/data-y attributes
          const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
          const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
          // translate the element
          target.style.webkitTransform = 'translate(' + x + 'px, ' + y + 'px)';
          target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

          // update the position attributes
          target.setAttribute('data-x', '' + x);
          target.setAttribute('data-y', '' + y);
        },
        onend: function (event) {
          const target: HTMLElement = event.target;

          // reset attributes of original element
          if (target) {
            target.style.position = 'static';
            target.style.zIndex = 'auto';
            target.style.left = 'auto';
            target.style.top = 'auto';
            target.style.webkitTransform = 'none';
            target.style.transform = 'none';
            target.setAttribute('data-x', '0');
            target.setAttribute('data-y', '0');
          }

          // remove clone
          if (target.parentElement) {
            target.parentElement.removeChild(clone);
          }
        }
      })
      .on('tap', function (event) {
        if (!classThis.isSmallStickerWidget) {
          event.preventDefault();
          setTimeout(() => {
            const sticker = classThis.templateStickers.find(s => s.id === +event.currentTarget.dataset.stickerid);
            classThis.changeIcon(sticker);
          }, 20);
        }
      })
      .on('doubletap', function (event) {
        if (!classThis.isSmallStickerWidget) {
          event.preventDefault();
          setTimeout(() => {
            const sticker = classThis.templateStickers.find(s => s.id === +event.currentTarget.dataset.stickerid);
            classThis.changeIcon(sticker);
          }, 20);
        }
      });
  }

  private setupStickerDropzone() {
    const obj = this;

    interact(this.dropzoneClass).dropzone({
      // only accept elements matching this CSS selector
      accept: this.draggableClass,
      // Require a 50% element overlap for a drop to be possible
      overlap: 0.50,
      // listen for drop related events:
      ondropactivate: function (event) {
      },
      ondragenter: function (event: any) {
        event.target.classList.add('droptarget');
      },
      ondragleave: function (event: any) {
        event.target.classList.remove('droptarget');
      },
      ondrop: function (event: any) {
        event.target.classList.remove('droptarget');

        const taskId = event.target.getAttribute('data-taskcardid');
        const userstoryId = event.target.getAttribute('data-userstoryid');

        if (taskId || userstoryId) {
          const id = (taskId) ? taskId : userstoryId;
          const stickerId = event.relatedTarget.getAttribute('data-stickerId');
          const eventPayload = { 'issueId': id, 'stickerId': stickerId };
          const componentEvent = new AwallComponentEvent(obj.dropEventName, eventPayload);
          obj.communicationService.sendData(KanbanBoardViewComponent.name, componentEvent);
        } else {
          console.log('Cant send event for dropped sticker. No component-id found');
        }
      },
    });
  }

  deleteSticker(sticker: Sticker) {
    const targetURL = this.baseURL + `stickers/${sticker.id}/`;

    return this.http.delete<Sticker>(targetURL).subscribe(data => {
      const index = this.templateStickers.indexOf(sticker);
      this.templateStickers.splice(index, 1);
      this.table.renderRows();
    });
  }

  updateSticker(originalSticker: Sticker, newSticker?: Sticker) {
    if (newSticker) { originalSticker.update(newSticker); }
    this.stickerService.updateSticker(originalSticker);
    this.expandedElement = null;
  }

  addStickerTemplate(sticker: Sticker, domElement?: JQuery<Element>) {
    this.stickerService.addSticker(sticker).subscribe(
      data => {
        const stickerData = this.stickerService.mapJSONToSticker(data);

        this.templateStickers.push(stickerData);
        this.table.renderRows();

        // scroll to bottom
        if (domElement) {
          domElement.animate({
            scrollTop: domElement.find('.content').height() + 50
          }, 2000).delay(20);
        }
      }
    );
  }

  removeSticker(sticker: Sticker) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: this.translate.instant('widgets.stickers.confirmDelete'),
        buttonTextConfirm: this.translate.instant('widgets.stickers.yes'),
        buttonTextCancel: this.translate.instant('widgets.stickers.no')
      },
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteSticker(sticker);
      }
    });
  }

  addSticker() {
    const emptySticker = new Sticker(0, 0, this.projectKey, '', '', 'help_center', '#888');
    const el = $('#stickerwidget > .widget');
    this.addStickerTemplate(emptySticker, el);
  }

  protected changeIcon(sticker: Sticker) {
    const dialogRef = this.dialog.open(StickerIconComponent, {
      data: { sticker: sticker }
    });

    dialogRef.afterClosed().subscribe(stickerNew => {

      if (stickerNew) {
        if (stickerNew.iconName === '' && stickerNew.imageData === '') {
          stickerNew.iconName = 'help_center';
          stickerNew.iconColor = '#888';
        }

        sticker.update(stickerNew);
        this.updateSticker(sticker);
      }
    });
  }
}
